export default __webpack_public_path__ + "static/media/kid2.fbe13a35.png";